document.addEventListener('DOMContentLoaded', function () {

  const loyolyPoints = document.querySelector('#loyoly-points');

  if (!loyolyPoints) return;

  let lastPriceCents = null;
  let lastMultiplier = null;
  let updateTimer = null;


  /* =====================================================
     QUANTITÉ RÉELLE
  ===================================================== */

  function getRealQuantity() {

    const quantityInput =
      document.querySelector('.js-qty-hidden');

    if (quantityInput) {
      const quantity = parseInt(quantityInput.value, 10);

      if (Number.isFinite(quantity) && quantity > 0) {
        return quantity;
      }
    }

    return 1;
  }


  /* =====================================================
     PRIX TEXTE → CENTIMES

     "30,38€" → 3038
     "17,95 €" → 1795
  ===================================================== */

  function parsePriceText(text) {

    if (!text) return null;

    const cleaned = text
      .replace(/\s/g, '')
      .replace('€', '')
      .replace(/\u00a0/g, '');

    const match =
      cleaned.match(/(\d+(?:[.,]\d{1,2})?)/);

    if (!match) return null;

    const euros =
      parseFloat(
        match[1].replace(',', '.')
      );

    if (!Number.isFinite(euros)) return null;

    return Math.round(euros * 100);
  }


  /* =====================================================
     ACHAT UNIQUE / ABONNEMENT

     On ne regarde PAS la value du radio :
     ton radio abonnement n'a pas forcément
     value="subscription".

     On regarde donc la classe du bloc parent.
  ===================================================== */

  function isSubscriptionSelected() {

    const checkedInput =
      document.querySelector(
        'subscription-widget input[name="purchase_type"]:checked'
      );

    if (!checkedInput) return false;

    const option =
      checkedInput.closest(
        '.subscription-widget__option'
      );

    if (!option) return false;

    return option.classList.contains(
      'subscription-widget__option--subscription'
    );
  }


  /* =====================================================
     QUANTITY BREAK EXACTEMENT CORRESPONDANT

     Exemple :

     quantité 1 → break 1
     quantité 2 → break 2
     quantité 3 → break 3
     quantité 4 → aucun break

     On ne prend JAMAIS le dernier break
     si la quantité est supérieure.
  ===================================================== */

  function getExactQuantityBreak(quantity) {

    const quantityBreaks =
      document.querySelector('quantity-breaks');

    if (!quantityBreaks) return null;

    const breaks =
      quantityBreaks.querySelectorAll(
        '[data-quantity]'
      );

    for (const quantityBreak of breaks) {

      const breakQuantity =
        parseInt(
          quantityBreak.dataset.quantity,
          10
        );

      if (
        Number.isFinite(breakQuantity) &&
        breakQuantity === quantity
      ) {
        return quantityBreak;
      }
    }

    return null;
  }


  /* =====================================================
     PRIX RÉELLEMENT PAYÉ

     Priorité :

     1. Abonnement → prix affiché abonnement
     2. Achat + Quantity Break exact → data-price
     3. Achat sans Quantity Break → prix affiché
  ===================================================== */

  function getRealPriceCents() {

    const subscriptionWidget =
      document.querySelector(
        'subscription-widget'
      );

    if (!subscriptionWidget) return null;

    const quantity =
      getRealQuantity();

    const isSubscription =
      isSubscriptionSelected();


    /* ===================================================
       ABONNEMENT

       Exemple :
       33,76 € achat unique
       30,38 € abonnement

       On prend le prix affiché par le widget.
    =================================================== */

    if (isSubscription) {

      const subscriptionPrice =
        subscriptionWidget.querySelector(
          '.subscription-widget__option--subscription .subscription-widget__new-price'
        );

      if (subscriptionPrice) {

        const price =
          parsePriceText(
            subscriptionPrice.textContent
          );

        if (price !== null) {
          return price;
        }
      }
    }


    /* ===================================================
       ACHAT UNIQUE + QUANTITY BREAK

       On utilise UNIQUEMENT le break correspondant
       à la quantité actuelle.
    =================================================== */

    if (!isSubscription) {

      const exactQuantityBreak =
        getExactQuantityBreak(quantity);

      if (exactQuantityBreak) {

        const priceElement =
          exactQuantityBreak.querySelector(
            '.quantity-break_price-container_price'
          );

        if (priceElement) {

          const price =
            parseInt(
              priceElement.dataset.price,
              10
            );

          if (
            Number.isFinite(price) &&
            price >= 0
          ) {
            return price;
          }
        }
      }
    }


    /* ===================================================
       ACHAT UNIQUE SANS QUANTITY BREAK

       Exemple :

       Quantity Breaks disponibles :
       1 / 2 / 3

       Quantité actuelle :
       4

       → on prend le prix du widget.
    =================================================== */

    const oneTimePrice =
      subscriptionWidget.querySelector(
        '.subscription-widget__option--one-time .subscription-widget__option-price > span'
      );

    if (oneTimePrice) {

      const price =
        parsePriceText(
          oneTimePrice.textContent
        );

      if (price !== null) {
        return price;
      }
    }


    return null;
  }


  /* =====================================================
     CALCUL DES POILS

     ACHAT UNIQUE :
       prix × 1

     ABONNEMENT :
       prix × 3

     ARRONDI TOUJOURS AU SUPÉRIEUR
  ===================================================== */

  function updateLoyolyPoints() {

    const priceCents =
      getRealPriceCents();

    if (priceCents === null) return;


    const isSubscription =
      isSubscriptionSelected();


    const multiplier =
      isSubscription ? 3 : 1;


    /*
     * On doit comparer également le multiplicateur.
     *
     * Exemple :
     *
     * Achat unique → 34 poils
     * Abonnement   → 102 poils
     *
     * même prix éventuel, mais résultat différent.
     */
    if (
      priceCents === lastPriceCents &&
      multiplier === lastMultiplier
    ) {
      return;
    }


    lastPriceCents =
      priceCents;

    lastMultiplier =
      multiplier;


    /*
     * Prix en euros
     */
    const priceEuros =
      priceCents / 100;


    /*
     * Calcul des points
     *
     * Achat unique :
     * 33,76 × 1 = 33,76 → 34
     *
     * Abonnement :
     * 30,38 × 3 = 91,14 → 92
     */
    const points =
      Math.ceil(
        priceEuros * multiplier
      );


    loyolyPoints.textContent =
      `Gagnez ${points} poils ! (1€ = 1 poil)`;
  }


  /* =====================================================
     MISE À JOUR DIFFÉRÉE

     On laisse les autres scripts terminer leur calcul
     avant de lire le prix.
  ===================================================== */

  function scheduleUpdate(delay = 200) {

    clearTimeout(updateTimer);

    updateTimer =
      setTimeout(
        updateLoyolyPoints,
        delay
      );
  }


  /* =====================================================
     QUANTITY BREAKS

     Ton Quantity Breaks envoie :
     quantity-breaks:quantity-selected
  ===================================================== */

  document.addEventListener(
    'quantity-breaks:quantity-selected',
    function () {

      scheduleUpdate(200);

    }
  );


  /* =====================================================
     QUANTITÉ CLASSIQUE

     Ton système envoie :
     form:quantity-update
  ===================================================== */

  document.addEventListener(
    'form:quantity-update',
    function () {

      scheduleUpdate(200);

    }
  );


  /* =====================================================
     ACHAT UNIQUE / ABONNEMENT

     On attend que le widget ait terminé
     de mettre son prix à jour.
  ===================================================== */

  document.addEventListener(
    'change',
    function (event) {

      if (
        event.target.matches(
          'input[name="purchase_type"], subscription-widget .deployer-select'
        )
      ) {

        scheduleUpdate(350);

      }

    }
  );


  /* =====================================================
     WIDGET ABONNEMENT

     Surveille :

     - changement de variante
     - changement de prix
     - changement de selling plan
     - changement de quantité
     - changement du contenu du widget
  ===================================================== */

  const subscriptionWidget =
    document.querySelector(
      'subscription-widget'
    );


  if (subscriptionWidget) {

    const observer =
      new MutationObserver(function () {

        scheduleUpdate(200);

      });

    observer.observe(
      subscriptionWidget,
      {
        childList: true,
        subtree: true,
        characterData: true
      }
    );
  }


  /* =====================================================
     QUANTITY BREAKS

     Surveille :

     - changement de sélection
     - changement de data-price
     - changement de quantité
  ===================================================== */

  const quantityBreaks =
    document.querySelector(
      'quantity-breaks'
    );


  if (quantityBreaks) {

    const observer =
      new MutationObserver(function () {

        scheduleUpdate(200);

      });

    observer.observe(
      quantityBreaks,
      {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: [
          'class',
          'data-price',
          'data-quantity'
        ]
      }
    );
  }


  /* =====================================================
     INITIALISATION

     Loyoly / Quantity Breaks / abonnement peuvent
     être chargés légèrement après le DOM.
  ===================================================== */

  let attempts = 0;

  const initialCheck =
    setInterval(function () {

      updateLoyolyPoints();

      attempts++;

      if (
        lastPriceCents !== null ||
        attempts >= 40
      ) {

        clearInterval(initialCheck);

      }

    }, 250);

});